export default {
  propostas: [],
  produtos: [],
  motivos: null,
  loading: false,
};
